import { itwApi } from '../middlewares/api';
const createAssetDetail = async (data) => {
    const response = await itwApi.post('/Assets', data);
    return response.data;
};
const createAssetIncident = async (data) => {
    const response = await itwApi.post('/Incident', data);
    return response.data;
};
const updateAssetDetail = async (assetId, data) => {
    const response = await itwApi.put(`/Assets/${assetId}`, data);
    return response.data;
};
const getAssetDetailbyId = async (id) => {
    var response = await itwApi.get(`Assets/get-assets-detail-by-id?id=${id}`);
    return response.data;
};
const deleteAssetDetailbyId = async (id) => {
    var response = await itwApi.delete(`Assets/${id}`);
    return response.data;
};
export const assetApi = {
    createAssetDetail,
    updateAssetDetail,
    getAssetDetailbyId,
    deleteAssetDetailbyId,
    createAssetIncident
};
